import cn from "classnames";
import styles from "./EquipmentSelector.module.scss";
import Icon from "../Icon/Icon";
import { useEquipmentSelectorControl } from "./useEquipmentSelectorControl";
import { IEquipmentSelectorProps } from "./EquipmentSelector.props";

import arrow from "@assets/icons/down-arrow.png";
import network from "@assets/icons/network.svg";
import electrical from "@assets/icons/electrical.svg";
import { EQUIPMENT_TYPE } from "@store/Equipments/actionTypes";

export default function EquipmentSelector({
  ...props
}: IEquipmentSelectorProps) {
  const { options, name, id, refresh, className, ...divProps } = props;
  const control = useEquipmentSelectorControl(props);

  const filteredEq = () => options.filter((item) => item !== control.value);
  return (
    <div className={cn(styles.wrapper, className)} {...divProps}>
      {name && <label>{name}</label>}
      <div
        className={cn(styles.selected, {
          [styles.open]: control.open,
        })}
        onClick={control.onOpen}
      >
        <div className={styles.value}>
          <Icon
            src={
              control.value === EQUIPMENT_TYPE.NETWORK ? network : electrical
            }
            className={cn(styles.icon_value)}
            noHover
          />
          <p>{control.value}</p>
        </div>
        <Icon
          src={arrow}
          className={cn(styles.icon, {
            [styles.active]: control.open,
          })}
          noHover
        />
      </div>
      <div
        className={cn(styles.options, {
          [styles.active]: control.open,
        })}
      >
        {filteredEq().length > 0 &&
          filteredEq().map((type, i) => (
            <div
              className={styles.option}
              key={type}
              onClick={() => control.onSelect(type as EQUIPMENT_TYPE)}
            >
              <Icon
                src={type === EQUIPMENT_TYPE.NETWORK ? network : electrical}
                className={cn(styles.icon_value)}
                noHover
              />
              <p>{type}</p>
            </div>
          ))}
      </div>
      <input defaultValue={control.value} tabIndex={-1} id={id} readOnly />
    </div>
  );
}
